import { cn } from "cn";

/** Base UI accepts a class name or a function of the part's state; both have to survive merging. */
export function merge<State>(
  base: string,
  className: string | ((state: State) => string | undefined) | undefined,
) {
  return (state: State) => cn(base, typeof className === "function" ? className(state) : className);
}
